'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoHappyOutline = function IoHappyOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.7 22.7c0.7 0.3 0.9 1 0.6 1.6-1.9 3.6-6.1 5.7-10.8 5.7-4.8 0-9.2-2.3-10.9-5.8-0.3-0.6 0-1.3 0.7-1.6 0.1-0.1 0.4-0.1 0.5-0.1 0.5 0 0.9 0.2 1.1 0.7 1.3 2.7 4.7 4.3 8.6 4.3 3.8 0 7.2-1.6 8.6-4.4 0.2-0.4 0.6-0.6 1.1-0.6 0.2 0 0.4 0.1 0.5 0.2z m2.1-4.7c0.4 0.6 0.3 1.4-0.3 1.8-0.3 0.1-0.5 0.2-0.8 0.2-0.4 0-0.9-0.2-1.1-0.5s-0.6-0.7-1.3-0.7-1.1 0.4-1.4 0.7-0.7 0.5-1.1 0.5c-0.3 0-0.5-0.1-0.8-0.2-0.6-0.5-0.7-1.2-0.2-1.8 0.9-1 1.8-1.7 3.5-1.7s2.7 0.7 3.5 1.7z m-17.5 0c0.4 0.6 0.3 1.4-0.3 1.8-0.3 0.1-0.5 0.2-0.8 0.2-0.4 0-0.9-0.2-1.1-0.5s-0.6-0.7-1.3-0.7-1.1 0.4-1.4 0.7-0.7 0.5-1.1 0.5c-0.3 0-0.5-0.1-0.8-0.2-0.6-0.5-0.7-1.2-0.2-1.8 0.9-1 1.8-1.7 3.5-1.7s2.7 0.7 3.5 1.7z m5.2-15.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.6 28.1c2.8-2.8 4.4-6.6 4.4-10.6s-1.6-7.8-4.4-10.6-6.6-4.4-10.6-4.4-7.8 1.6-10.6 4.4-4.4 6.6-4.4 10.6 1.6 7.8 4.4 10.6 6.6 4.4 10.6 4.4 7.8-1.6 10.6-4.4z' })
        )
    );
};

exports.default = IoHappyOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/happy-outline.js
// module id = 2039
// module chunks = 0